import { atom } from 'jotai';

export const errorAtom = atom({
  message: '',
  description: '',
  action: <div />
});
